import { connect, useDispatch } from 'react-redux';
import PUProfile from '../PUProfile';
import React, { useEffect } from 'react';
import { VirtuosoGrid } from 'react-virtuoso';

import './style.scss';
import { getSearchUsers } from '../../../redux/actions/search';
import PUProfileSkeleton from '../PUProfile/Skeleton';

const PER_PAGE = 15;

const UserContents = ({
    users,
    total,
    hasMore,
    keyword,
    busy,
}) => {
    const dispatch = useDispatch();
    const handleGetUsers = () => {
        if (hasMore) {
            dispatch(getSearchUsers({
                perPage: PER_PAGE,
                keyword: keyword,
                skip: users && users.length > 0 ? users.length : 0
            }));
        }
    };

    return <div className='user-contents'>
        {
            users && users.length > 0
                ? <VirtuosoGrid
                    style={{
                        height: '75vh'
                    }}
                    overscan={PER_PAGE}
                    totalCount={total}
                    endReached={handleGetUsers}
                    data={users}
                    itemClassName='user__card'
                    components={{
                        PUProfile
                    }}
                    itemContent={(index, user) => <React.Fragment>
                        {
                            user && Object.keys(user).length > 0 ? <PUProfile user={user} key={index} /> : null
                        }
                    </React.Fragment>}
                />
                : null
        }

        {
            busy
                ? <PUProfileSkeleton />
                : null
        }

        {
            !busy && users && users.length <= 0
                ? <div className='no-user-found'>
                    No creator found
                </div>
                : null
        }

    </div>;
};

const mapStateToProps = state => ({
    users: state.search.users,
    total: state.search.total,
    hasMore: state.search.hasMore,
    keyword: state.search.keyword,
    busy: state.search.busy
});

export default connect(mapStateToProps)(UserContents);